var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "19px",
    viewBox: "0 0 28 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Show") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Show",
    transform: "translate(0.591578, -0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4084215,8.8817842e-16 C8.05491823,0.000630687836 3.10473745,2.84508072 0.408421521,7.47 C-0.136140507,8.41731672 -0.136140507,9.58268328 0.408421521,10.53 C3.08538537,15.1804164 8.04255639,18.0466852 13.4084215,18.0466852 C18.7742866,18.0466852 23.7314577,15.1804164 26.4084215,10.53 C26.9529835,9.58268328 26.9529835,8.41731672 26.4084215,7.47 C23.7121056,2.84508072 18.7619248,0.000630687836 13.4084215,8.8817842e-16 Z M24.6584215,9.52 C22.3340272,13.5340931 18.0469291,16.0055929 13.4084215,16.0055929 C8.76991398,16.0055929 4.48281587,13.5340931 2.15842152,9.52 C1.97978873,9.21059892 1.97978873,8.82940108 2.15842152,8.52 C4.48539047,4.51562947 8.76703211,2.05164604 13.3984215,2.05164604 C18.0298109,2.05164604 22.3114526,4.51562947 24.6384215,8.52 L24.6384215,8.52 C24.8232834,8.82581654 24.8309078,9.2070365 24.6584215,9.52 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4084215,4 C10.6469978,4 8.40842152,6.23857625 8.40842152,9 C8.40842152,11.7614237 10.6469978,14 13.4084215,14 C16.1698453,14 18.4084215,11.7614237 18.4084215,9 C18.4084215,7.67391755 17.8816373,6.40214799 16.9439554,5.46446609 C16.0062735,4.5267842 14.734504,4 13.4084215,4 Z M13.4084215,12 C11.7515673,12 10.4084215,10.6568542 10.4084215,9 C10.4084215,7.34314575 11.7515673,6 13.4084215,6 C15.0652758,6 16.4084215,7.34314575 16.4084215,9 C16.4084215,10.6568542 15.0652758,12 13.4084215,12 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/Show-Password.fdc1e8ce.svg";
export { ForwardRef as ReactComponent };